module.exports = __webpack_public_path__ + "media/universfield-happy-message-ping-351298.ec862a18.mp3";